import * as React from 'react';
import parse from 'html-react-parser';

import CoursePageActivity from './course_page_activity'
import QuillResourceLink from './quill_resource_link'
import { TEKS_COURSE_PAGE, TEKS_PREMIUM_TOOLTIP_TEXT } from '../../constants/contentHubs';
import { SPONSORED_SUBSCRIPTION_TYPES } from '../../components/subscriptions/constants'
import { Tooltip } from '../../../Shared';

const expandImgSrc = `${window.postbuildEnv.CDN_URL}/images/icons/s/expand.svg`
const collapseImgSrc = `${window.postbuildEnv.CDN_URL}/images/icons/s/collapse.svg`

const CoursePageUnitTemplate = ({ toggleUnitTemplateExpansion, unitTemplate, expandedUnitTemplateIds, subscriptionType, courseType }) => {
  const { display_name, activities, all_oer_articles, all_quill_articles_href, description, oer_unit_teacher_guide, oer_unit_website, oer_unit_number, fishtank_unit_number, fishtank_unit_website, quill_teacher_guide_href, unit_template_id, } = unitTemplate

  function handleClickToggle() {
    toggleUnitTemplateExpansion(unit_template_id)
  }

  function renderPreviewAndAssignButton() {
    if (courseType === TEKS_COURSE_PAGE && !SPONSORED_SUBSCRIPTION_TYPES.includes(subscriptionType)) {
      return (
        <Tooltip
          tooltipText={TEKS_PREMIUM_TOOLTIP_TEXT}
          tooltipTriggerText={<button className="quill-button medium contained disabled focus-on-light" disabled={true} type="button"><img alt="" src="https://assets.quill.org/images/icons/xs/lock.svg" /> Preview & Assign</button>}
        />
      )
    }
    return <a className="quill-button medium green focus-on-light contained" href={`/assign/featured-activity-packs/${unit_template_id}`}>Preview & Assign</a>
  }

  const isExpanded = expandedUnitTemplateIds.includes(unit_template_id)

  let previewAndAssignButton = <button className="quill-button medium contained disabled focus-on-light" disabled={true} type="button">Coming Soon</button>
  let expandOrCollapseButton

  if (unit_template_id) {
    previewAndAssignButton = renderPreviewAndAssignButton()

    const expandOrCollapseButtonImageSrc = isExpanded ? collapseImgSrc : expandImgSrc
    const expandOrCollapseButtonAriaLabel = isExpanded ? `Collapse ${display_name} activities` : `Expand ${display_name} activities`

    expandOrCollapseButton = (
      <button
        aria-expanded={isExpanded}
        aria-label={expandOrCollapseButtonAriaLabel}
        className="interactive-wrapper focus-on-light"
        onClick={handleClickToggle}
        type="button"
      >
        <img alt="" src={expandOrCollapseButtonImageSrc} />
      </button>
    )
  }

  let quillResourceLinks
  let activitiesSection
  let oerResourcesSection
  let fishtankResourcesSection
  let aiEduResourcesSection

  if (isExpanded) {
    quillResourceLinks = (
      <div className="quill-resource-links">
        {!!quill_teacher_guide_href?.length && <QuillResourceLink href={quill_teacher_guide_href} text="Quill Teacher Guide" />}
        {!!all_quill_articles_href?.length && <QuillResourceLink href={all_quill_articles_href} text="Download all unit texts" />}
      </div>
    )

    if (activities?.length) {
      activitiesSection = (
        <div className="activities-section">
          <h4>Activities</h4>
          {activities.map(activity => <CoursePageActivity activity={activity} courseType={courseType} key={activity.display_name} subscriptionType={subscriptionType} />)}
        </div>
      )
    }

    oerResourcesSection = oer_unit_number && (
      <div className="resources-section">
        <h4>OER Project Unit {oer_unit_number} Resources</h4>
        <div className="links">
          <a className="quill-button focus-on-light small outlined grey" href={oer_unit_website} rel="noopener noreferrer" target="_blank">OER Project Unit {oer_unit_number} website</a>
          <a className="quill-button focus-on-light small outlined grey" href={oer_unit_teacher_guide} rel="noopener noreferrer" target="_blank">OER Project Unit {oer_unit_number} teacher guide</a>
          {all_oer_articles && <a className="quill-button focus-on-light small outlined grey" href={all_oer_articles} rel="noopener noreferrer" target="_blank">Download all OER Project Unit {oer_unit_number} articles</a>}
        </div>
      </div>
    )

    fishtankResourcesSection = fishtank_unit_number && (
      <div className="resources-section">
        <h4>Fishtank ELA Unit {fishtank_unit_number} Resources</h4>
        <div className="links">
          <a className="quill-button focus-on-light small outlined grey" href={fishtank_unit_website} rel="noopener noreferrer" target="_blank">Fishtank ELA Unit {fishtank_unit_number} website</a>
        </div>
      </div>
    )

    aiEduResourcesSection = activities?.find(act => act.paired_ai_edu_activities?.length) && (
      <div className="resources-section">
        <h4>aiEDU Aligned Resources</h4>
        <div className="links">
          <a className="quill-button focus-on-light small outlined grey" href="https://www.aiedu.org/teach-ai?utm_source=quill&utm_medium=web&utm_campaign=quill_curriculum " rel="noopener noreferrer" target="_blank">aiEDU website</a>
        </div>
      </div>
    )
  }

  return (
    <section aria-labelledby={display_name} className="course-page-unit-template">
      <div className="unit-template-header">
        <div className="name-and-buttons">
          <h3 id={display_name}>{display_name}</h3>
          <div>
            {previewAndAssignButton}
            {expandOrCollapseButton}
          </div>
        </div>
        <p className="unit-template-description">{parse(description)}</p>
        {quillResourceLinks}
      </div>
      {activitiesSection}
      {oerResourcesSection}
      {fishtankResourcesSection}
      {aiEduResourcesSection}
    </section>
  )
}

export default CoursePageUnitTemplate
